<script>
    import { onMount } from 'svelte';
    import { fetchOneBookCourse } from '/public/services/courses.js';
    import { fade, slide } from 'svelte/transition';
    import LoginUser from '/public/components/user/LoginUser.svelte';
    import IndividualPerson from '/public/components/booking/IndividualPerson.svelte';
    import OrganisationCreate from '/public/components/booking/OrganisationCreate.svelte';
    

    export let currentRoute;

    let id = currentRoute.namedParams.courseID;
    let loading = true;
    let course = null;
    let provinces = null;
    let page_state = null;
    let show_error = false;

    let obj =  {
        course_type_id: null,
        courseType: null,
        type: null,
        email: null,
        secondary_email: null,
        first_name: null,
        last_name: null,
        password: null,
        password_confirmation: null,
        title: null,
        address1: null,
        address2: null,
        suburb: null,
        city: null,
        postcode: null,
        province_id: null,
        province_name: null,
        physical_province_id: null,
        physical_province_name: null,
        country: 'New Zealand',
        physical_address1: null,
        physical_address2: null,
        physical_suburb: null,
        physical_city: null,
        physical_postcode: null,
        physical_province: 15,
        physical_country: 'New Zealand',
        course_id: id,
        dob: null,
        nsn: null,
        has_physical_address: false,
        phone: null,
        mobile: null,
        is_student: null
    };

    function loadCourse() {
        fetchOneBookCourse(id).then(res => {
            if (res.success) {
                course = res.data.course;
                provinces = res.data.provinces;

                if (res.data.obj != null) {
                    show_error = true;
                    //obj = res.data.obj;

                    if (obj.type == 'I') {
                        //page_state = 'i';
                    }
                }

                loading = false;
            }
        });
    }

    function setIndividual() {
        obj.type = 'I';
        page_state = 'i';
    }
    
    function setOrganisation() {
        obj.type = 'O';
        page_state = 'o';
    }

    function cancelCreate() {
        page_state = null;
        obj.type = null;
    }

    function cancelIndividual() {        
        page_state = 'create';
        obj.type = null;
    }

    function cancelOrganisation() {
        page_state = 'create';
        obj.type = null;
    }

    onMount(() => {
        loadCourse();
    });


</script>
{#if loading === true}

    <div class='text-center'>
        <h4>
            <span class='ajax-ball-loader'></span> Loading Course....
        </h4>
    </div>

{:else}

    <p class='text-end'>
        <a href='/courses/{ id }' class='btn btn-outline-secondary btn-sm'>
            <span class='fas fa-plus-circle'></span> Back to Course
        </a>
    </p>

    <h4>
        Book Course: { course.title }
    </h4>

    {#if show_error === true}

        <div class='alert alert-info clearfix mb-3' in:slide>
            <h4 class='float-start me-3'>
                <span class='fas fa-info-circle'></span>
            </h4>
            There was an issue with payment for your booking.<br/>
            Please contact <span class='fas fa-envelope'></span> { course.support_email } or <span class='fas fa-mobile'></span> { course.support_phone } for assistance.
        </div>

    {:else}

        <div class='alert alert-info mb-3'>
            <div class='clearfix'>
                <h4 class='float-start me-3'>
                    <span class='fas fa-info-circle'></span>
                </h4>
                For assistance with booking your course please contact:
            </div>
            <span class='fas fa-envelope'></span> { course.support_email }            
            <br/>
            <span class='fas fa-mobile'></span> { course.support_phone }.
        </div>

    {/if}

    {#if page_state == null}

        <section in:fade>
            <div class='alert alert-secondary mb-3'>
                <span class='fas fa-info-circle'></span> Hi, before we can book you into <span class='fw-bold'>{ course.title }</span> we need to log you in or create a new account. 
            </div>
        </section>

        <div class='row justify-content-center'>
            <div class='col-sm-12 col-md-8 col-lg-6'>
                <div class='card mb-3'>
                    <div class='card-header'>
                        Account Information
                    </div>
                    <div class='card-body'>
                        <div class='row'>
                            <div 
                                class='col-md-6 col-sm-12'                                
                            >
                                <div class='d-grid mb-3'>
                                    <button type='button' class='btn btn-outline-primary' on:click={() => page_state = 'create'}>
                                        <span class='fas fa-plus-circle'></span> I need to create an Account
                                    </button>
                                </div>                                
                            </div>   
                            <div 
                                class='col-md-6 col-sm-12'                                
                            >
                                <div class='d-grid mb-3'>
                                    <button type='button' class='btn btn-outline-primary' on:click={() => page_state = 'login'}>
                                        <span class='fas fa-sign-in-alt'></span> Login to my Account
                                    </button>
                                </div>                                 
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

    {/if}

    {#if page_state == 'login'}

        <p class='text-end'>
            <button type='button' class='btn btn-outline-secondary' on:click={() => page_state = null}>
                <span class='fas fa-check-circle'></span> Cancel
            </button>                
        </p>

        <section in:fade>

            <LoginUser/>

        </section>

    {/if}

    {#if page_state == 'create'}

        <p class='text-end'>
            <button type='button' class='btn btn-outline-secondary' on:click={cancelCreate}>
                <span class='fas fa-check-circle'></span> Cancel
            </button>                
        </p>

        <section in:fade>
            <div class='row justify-content-center'>
                <div class='col-sm-12 col-md-10 col-lg-8'>
                    <div class='card mb-3'>
                        <div class='card-header'>
                            Account Type
                        </div>
                        <div class='card-body'>
                            <div class='row'>
                                <div 
                                    class='col-md-6 col-sm-12'                                                                        
                                >
                                    <div class='text-center'>
                                        <h4>
                                            Individual
                                        </h4>
                                    </div>
                                    <div class='d-grid mb-3'>
                                        <button type='button' class='btn btn-outline-primary' on:click={setIndividual}>
                                            <span class='fas fa-user'></span> I am an Individual and want to book myself onto a First Aid course.
                                        </button>
                                    </div>                                    
                                </div>   
                                <div 
                                    class='col-md-6 col-sm-12'                                   
                                >
                                    <div class='text-center'>
                                        <h4>
                                            Organisation
                                        </h4>
                                    </div>
                                    <div class='d-grid mb-3'>
                                        <button type='button' class='btn btn-outline-primary' on:click={setOrganisation}>
                                            <span class='fas fa-users'></span> I am an organisation and want to book multiple people onto a First Aid course.
                                        </button>
                                    </div>                                    
                                </div>                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </section>

    {/if}

    {#if page_state == 'i'}

        <p class='text-end'>
            <button type='button' class='btn btn-outline-secondary' on:click={cancelIndividual}>
                <span class='fas fa-check-circle'></span> Cancel
            </button>
        </p>

        <section in:fade>
            <div class='row justify-content-center'>
                <div class='col-sm-12 col-md-10 col-lg-8'>
                    <div class='card mb-3'>
                        <div class='card-header'>
                            <span class='fas fa-user'></span> Create Account
                        </div>
                        <div class='card-body'>

                            <IndividualPerson
                                course={course}
                                obj={obj}
                                provinces={provinces}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </section>

    {/if}
    
    {#if page_state == 'o'}

        <p class='text-end'>
            <button type='button' class='btn btn-outline-secondary' on:click={cancelOrganisation}>
                <span class='fas fa-check-circle'></span> Cancel
            </button>
        </p>

        <section in:fade>
            <div class='row justify-content-center'>
                <div class='col-sm-12 col-md-10 col-lg-8'>
                    <div class='card mb-3'>
                        <div class='card-header'>
                            <span class='fas fa-user'></span> Create Account
                        </div>
                        <div class='card-body'>

                            <OrganisationCreate
                                course={course}
                                obj={obj}
                                provinces={provinces}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </section>

    {/if}

{/if}